(function () {
  angular
    .module("akitabox.desktop.request.detail")
    .controller("RequestFloorTabController", RequestFloorTabController);

  /* @ngInject */
  function RequestFloorTabController(
    $timeout,
    building,
    request,
    FloorService,
    ToastService
  ) {
    var self = this;

    // Attributes
    self.loading = true;
    self.rendering = true;
    self.building = building;
    self.request = request;
    self.floor = null;

    init();

    function init() {
      var floorId = request.level._id;
      FloorService.getById(building._id, floorId)
        .then(function (floor) {
          self.floor = floor;
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.loading = false;
          $timeout(function () {
            self.rendering = false;
          }, 500);
        });
    }
  }
})();
